module.exports = __webpack_public_path__ + "static/diagram1-6544b9cd7cc0198d82dedf60ae27a87a.jpg";